import * as go from 'gojs';

export const addToken = (diagram: go.Diagram, { color, leader }) => {
    const prevSkips = diagram.skipsUndoManager;
    const prevIsOngoing = diagram.layout.isOngoing;
    diagram.skipsUndoManager = true;
    diagram.layout.isOngoing = false;
    diagram.model.addNodeDataCollection([
        { category: 'token', at: 0, frac: 0.0, color, leader },
    ]);
    diagram.skipsUndoManager = prevSkips;
    diagram.layout.isOngoing = prevIsOngoing;
};

export const removeToken = (diagram: go.Diagram, part: go.Part) => {
    const prevIsOngoing = diagram.layout.isOngoing;
    diagram.layout.isOngoing = false;
    diagram.remove(part);
    diagram.layout.isOngoing = prevIsOngoing;
};
